import { FC } from 'react'
import router from 'next/router'
import { Row, Col, Pagination } from '@/client/components'
import { useRouterPush } from '@/client/hooks'
import * as S from './styles'
import { BlogCard } from '../Components'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BlogGrid: FC<any> = ({ blogLists, meta, gridtype }) => {
  const { query } = useRouterPush()

  const handlePageChange = (pageNumber) => {
    const basePath = router.pathname
    // Blog main pagination
    if (basePath === '/blog' || basePath === '/blog/page/[page]') {
      if (pageNumber === 1) {
        router.push('/blog')
      } else {
        router.push(`/blog/page/${pageNumber}`)
      }
    }

    // Tag-based pagination
    else if (basePath.includes('/blog/tag')) {
      if (pageNumber === 1) {
        router.push(`/blog/tag/${meta['keyword']}`)
      } else {
        router.push(`/blog/tag/${meta['keyword']}/page/${pageNumber}`)
      }
    }

    // Search-based pagination
    else if (basePath.includes('/blog/search')) {
      if (pageNumber === 1) {
        router.push(`/blog/search/${meta['keyword']}`)
      } else {
        router.push(`/blog/search/${meta['keyword']}/page/${pageNumber}`)
      }
    }
  }
  return (
    <Row>
      <Col xs='12' noGutter>
        <S.BlogItemWrapper>
          {blogLists.map((blogItem) => (
            <S.SingleBlogCard key={`key_${gridtype}`} gridtype={gridtype}>
              <BlogCard item={blogItem} />
            </S.SingleBlogCard>
          ))}
        </S.BlogItemWrapper>
      </Col>
      <Col xs='12'>
        {Number(meta['totalItems']) > 6 && (
          <S.PaginationWrapper>
            <Pagination
              currentPage={Number(query['page']) || 1}
              totalPages={meta['totalPages']}
              onPageChange={handlePageChange}
            />
          </S.PaginationWrapper>
        )}
      </Col>
    </Row>
  )
}
